<template>
    <div class="uploadImg clear">
        <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :http-request="httpRequest"
            :on-exceed="handleExceed" name="file" 
            :limit="limit"
            :before-remove="handleDelete"
            :file-list="fileList"
            ref="elUploadRef"
        >
            <img v-if="url" :src="url" class="avatar"/>
            <el-icon v-else class="avatar-uploader-icon"></el-icon>
            <div ref="uploadRef"></div>
        </el-upload>
        <div class="uploadInfo">
            <div class="ask">
                <div>图片格式要求：.jpg .png</div>
                <div>大小要求：2M以内</div>
                <div v-if="imgSize">推荐尺寸：{{ imgSize }}</div>
                <div v-else>推荐尺寸：200*200</div>
            </div>
            <div class="upload-demo">
                <el-button type="primary" @click="uploadBtn">点击上传</el-button>
            </div>
        </div>
        
    </div>
</template>
  
<script setup>
import * as qiniu from "qiniu-js";
import { ref,reactive,getCurrentInstance,computed,watch } from 'vue'
import { getPictureToken } from "../../server/jigou/org";
import { v4 as uuidv4 } from "uuid";
const uploadRef = ref(null)
const elUploadRef = ref(null)
const props = defineProps({
    modelValue: [String, Object, Array],
    // 图片数量限制
    limit: {
        type: Number,
        default: 1,
    },
    // 大小限制(MB)
    fileSize: {
        type: Number,
        default: 2,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
        type: Array,
        default: () => ["png", "jpg", "jpeg"],
    },
    // 是否显示提示
    isShowTip: {
        type: Boolean,
        default: true
    },
    url:{
        type: String,
        default:""
    },
    imgSize:{
        type: String,
        default:""
    }
});
console.log('props',props);
const { proxy } = getCurrentInstance();
const emit = defineEmits();
// const imageUrl = ref('')
const number = ref(0);
const uploadList = ref([]);
const baseUrl = '';
const fileList = ref([]);
const videoTypeArray = reactive([

])

const showTip = computed(
    () => props.isShowTip && (props.fileType || props.fileSize)
);

watch(() => props.modelValue, val => {
    // console.log('val1111',val);
    if (val) {
        // 首先将值转为数组
        const list = Array.isArray(val) ? val : props.modelValue.split(",");
        // 然后将数组转为对象数组
        fileList.value = list.map(item => {
            if (typeof item === "string") {
                if (item.indexOf(baseUrl) === -1) {
                    item = { name: baseUrl + item, url: baseUrl + item };
                } else {
                    item = { name: item, url: item };
                }
            }
            return item;
        });
    } else {
        fileList.value = [];
        return [];
    }
}, { deep: true, immediate: true });

// 上传成功回调
function handleUploadSuccess(res) {
    console.log('上传成功回调',res);
    uploadList.value.push({ name: res.fileName, url: res.fileName });
    if (uploadList.value.length === number.value) {
        console.log('fileName',res.fileName);
    //    imageUrl.value = res.fileName
        fileList.value = fileList.value.filter(f => f.url !== undefined).concat(uploadList.value);
        uploadList.value = [];
        number.value = 0;
        emit("handleUploadSuccess", listToString(fileList.value))
        proxy.$modal.closeLoading();
        fileList.value = [];
    }
}
async function httpRequest(file) {
    console.log('httpRequest')
    // 获取签名
    const res = await getPictureToken()
    var keyPrefix = "classroom/";
    const token = res.token,
        key = keyPrefix + uuidv4() + "." + file.file.name.split(".")[1],
        putExtra = {
            fname: file.name,
            // mimeType: file.type,
        },
        config = {
            useCdnDomain: true,
            region: res.region
        };
    let observer = {
        next(res) {
            console.log(res)
            console.log('已上传大小，单位为字节：' + res.total.loaded)
            console.log('本次上传的总量控制信息，单位为字节：' + res.total.size)
            console.log('当前上传进度，范围：0～100：' + res.total.percent);
        },
        error(err) {
            console.log(err)
            console.log(err.code)
            console.log(err.message)
            console.log(err.isRequestError)
            console.log(err.reqId)
        },
        complete(res) {
            console.log(res)
            handleUploadSuccess({ fileName: res.data.url });
        }
    };

    const observable = qiniu.upload(file.file, key, token, putExtra, config)
    const subscription = observable.subscribe(observer) // 上传开始
    console.log(subscription);
}

// 上传前loading加载
function handleBeforeUpload(file) {
    console.log('handleBeforeUpload')
    let isImg = false;
    if (props.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = props.fileType.some(type => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
        });
    } else {
        isImg = file.type.indexOf("image") > -1;
    }
    if (!isImg) {
        proxy.$modal.msgError(
            `文件格式不正确, 请上传${props.fileType.join("/")}图片格式文件!`
        );
        fileList.value = [];
        return false;
    }
    if (props.fileSize) {
        const isLt = file.size / 1024 / 1024 < props.fileSize;
        if (!isLt) {
            proxy.$modal.msgError(`上传头像图片大小不能超过 ${props.fileSize} MB!`);
            fileList.value = [];
            return false;
        }
    }
    proxy.$modal.loading("正在上传图片，请稍候...");
    number.value++;
}

// 文件个数超出
function handleExceed() {
    console.log(number.value);
    proxy.$modal.msgError(`上传文件数量不能超过 ${props.limit} 个!`);
}

// 上传失败
function handleUploadError() {
    proxy.$modal.msgError("上传图片失败");
    proxy.$modal.closeLoading();
    fileList.value = [];
}

// 对象转成指定字符串分隔
function listToString(list, separator) {
    let strs = "";
    separator = separator || ",";
    for (let i in list) {
        if (undefined !== list[i].url && list[i].url.indexOf("blob:") !== 0) {
            strs += list[i].url.replace(baseUrl, "") + separator;
        }
    }
    return strs != "" ? strs.substr(0, strs.length - 1) : "";
}
//模拟点击上传图片
function uploadBtn() {
    uploadRef.value.click()
}

function handleDelete(){
    console.log("delete...")
    return false;
}
</script>
<style scoped>
.uploadImg{
    display: flex;align-items: flex-start;
}
.avatar-uploader{
    width: 112px;height: 112px;
}
.avatar-uploader-icon{
    width: 112px;height: 112px;
}
.avatar-uploader-icon {
    background: url(data:image/png;base64,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) no-repeat;
    background-size: 100%;
}
.uploadInfo{
    margin-left: 20px;
}
.avatar{
    width: 112px;height: 112px;
}
</style>
  